import React, { useEffect } from "react";
import "./model-viewer-wrapper.css";

export default function ModalViewerWrapper({
  model,
  className,
  showDetailsCheckBox = true,
  showControlsOrbit = true,
}) {
  const modelRef = React.useRef();
  const [defaultColur, setDefaultColor] = React.useState([]);

  const checkBoxEvent = (e) => {
    const material = modelRef.current?.model?.materials;
    if (e.target.checked) {
      for (let i = model.info.annotationStartsFrom; i < material.length; i++) {
        modelRef.current.model.materials[i].setAlphaMode("MASK");

        const new_color =
          modelRef.current.model.materials[i].pbrMetallicRoughness
            .baseColorFactor;
        let setColor = [...new_color];
        // setColor[3] = Number(!setColor[3])
        setColor[3] = 1;
        modelRef.current.model.materials[
          i
        ].pbrMetallicRoughness.setBaseColorFactor(setColor);
      }
    } else {
      for (let i = model.info.annotationStartsFrom; i < material.length; i++) {
        modelRef.current.model.materials[i].setAlphaMode("MASK");
        const new_color =
          modelRef.current.model.materials[i].pbrMetallicRoughness
            .baseColorFactor;
        let setColor = [...new_color];
        // setColor[3] = Number(!setColor[3])
        setColor[3] = 0;
        modelRef.current.model.materials[
          i
        ].pbrMetallicRoughness.setBaseColorFactor(setColor);
      }
    }
  };

  const getModalColor = () => {
    const material = modelRef.current?.model?.materials;
    if (material) {
      // console.log("called")
      const color = material.map((item, index) => {
        modelRef.current.model.materials[index].setAlphaMode("MASK");
        return modelRef.current.model.materials[index].pbrMetallicRoughness
          .baseColorFactor;
      });
      setDefaultColor(color);
    }
  };

  const onProgress = (event) => {
    if (event.detail.totalProgress) {
      getModalColor();
    }
  };

  useEffect(() => {
    document
      .querySelector("model-viewer")
      .addEventListener("progress", onProgress);
  }, []);

  const getModalViewerProps = () => {
    const defaultProps = {
      src: model.info.model,
      poster: model.info.poster,
      alt: "Shop3D",
      exposure: model.info.exposure,
      "camera-orbit": model.info.cameraOrbit,
      class: className,
      ...model.info.optionalAttr,
      "min-camera-orbit": "auto 0deg auto",
      "max-camera-orbit": "auto 75deg auto",
      "auto-rotate": "true",
      "ar-modes": model.info.optionalAttr.arModes,
      "shadow-intensity": model.info.shadowIntensity,
    };
    if (showControlsOrbit) {
      return { ...defaultProps, "camera-controls": true };
    }
    return defaultProps;
  };
  return (
    <>
      <model-viewer
        ar
        ar-scale={model.info.arScale}
        ref={modelRef}
        {...getModalViewerProps()}
      />
      {showDetailsCheckBox && (
        <div className="leading-none inline-flex bg-gray-100 bottom-0 left-0 ml-2 mt-2 mb-1 rounded-full px-2 py-1 items-end">
          <div className="mr-1  text-sm font-bold flex items-end">
            <div
              className="bg-white text-xs font-bold hidden "
              id="checkBoxDiv"
            >
              <input
                type="checkbox"
                onChange={checkBoxEvent}
                defaultChecked={true}
              ></input>
              <label className="text-black">Show details</label>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
